import axios from 'axios'

const API = window.URL_API

export const create = (origin, origin_id) =>
axios.post(`${API}interests/save`, {
    data: JSON.stringify([{
        origin,
        origin_id, 
        status: 'created'
    }])
})

export const convert = (origin, origin_id) =>
axios.post(`${API}interests/save`, {
    data: JSON.stringify([{
        origin,
        origin_id, 
        status: 'converted'
    }])
})




// WEBPACK FOOTER //
// ./src/SPRINTA/utils/interests.js